// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import InstallerSharedInstallations from "../../components/Dashboard/InstallerSharedInstallations.js";
import WidgetDetail from '../../components/Dashboard/WidgetDetail';

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postListInstallerSharedInstallations = endpointHelias+'/Helias/V0/General/postListInstallerSharedInstallations'

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var dashboardCommonJS = require("../../js/dashboardCommon.js");

function mostrarDetalleWidget(widget, idInstalacion){

  dashboardCommonJS.cargarDatosInstalacionCompartidaInstalador(idInstalacion)

  document.getElementById("figureDetalleMeteo").className = "hidden"
  document.getElementById("figureDetalleWidget").className = "hidden"

  document.getElementById("detalleMETEO").className = "hidden"
  document.getElementById("detallePrevision7Dias").className = "hidden"
  document.getElementById("detalleINSTALACION").className = "hidden"
  document.getElementById("detalleACTIVIDAD_INSTALACION").className = "hidden"
  document.getElementById("detalleFV").className = "hidden"
  document.getElementById("detalleBATERIAS").className = "hidden"
  document.getElementById("detalleGRUPOELECTROGENO").className = "hidden"
  document.getElementById("detalleCOCHE").className = "hidden"
  document.getElementById("detalleAUTOCONSUMO_AHORRO").className = "hidden"

  dashboardCommonJS.operarDetalleLateral("abrir")
  
  var accesoDirectoWidget = ""

  if(widget.split("|")[0] === "AUTOCONSUMO_AHORRO"){    
    accesoDirectoWidget = widget.split("|")[1]
    widget = widget.split("|")[0] //No cambiar el orden    
  }

  document.getElementById("detalle"+widget).className = ""

  if(widget === "AUTOCONSUMO_AHORRO"){
    document.getElementById("detalleLateral").className = "modal lateral-detail"
    document.getElementById("figureDetalleWidget").className = "avatar size-xl cyan"
    document.getElementById("iconoDetalleWidget").innerHTML = "euro"   
    document.getElementById("tituloDetalleWidget").innerHTML = "Economía" 
    document.getElementById("detalleAUTOCONSUMO_AHORRO").className = "vertical gap-08"   
    
    //Para el caso del dashboard del instalador reseteo la visibilidad de los campos por si consulta varias instalaciones con distintas características.                  
    var elementosOcultos = document.getElementById("detalleAUTOCONSUMO_AHORRO").getElementsByClassName(" hidden");    
    for(var x=0; x < elementosOcultos.length ; x++){        
      if(!elementosOcultos[x].id.includes("AvisoRegalandoDinero")){
        elementosOcultos[x].className = elementosOcultos[x].className.replaceAll(" hidden", "")
      }      
    }

    if(accesoDirectoWidget === "1"){      
      if(!document.getElementById("figureFVGenerando"+idInstalacion).className.includes("hidden")){
        dashboardCommonJS.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","Hoy")
      }
      else{
        dashboardCommonJS.mostrarPestañaAutoconsumoFactura("pestañaFactura","Hoy")
      }      
    }
    else{    
      if( document.getElementById("valorMesPorcentajeReactiva").className.includes("error") ){
        // En este caso no hago nada para no machacar cambios de alertas
      }
      else{
        if(document.getElementById("statusConexionRed"+idInstalacion).innerHTML === "true" ){
          dashboardCommonJS.mostrarPestañaAutoconsumoAhorro("pestañaHoy")
          dashboardCommonJS.mostrarPestañaAutoconsumoFactura("pestañaFactura","Hoy")
        }
        else{           
          dashboardCommonJS.mostrarPestañaAutoconsumoAhorro("pestañaHoy")
          dashboardCommonJS.mostrarPestañaAutoconsumoFactura("pestañaAutoconsumo","Hoy")
        }
      }
      
    } 
    
  } 

}

// DASHBOARD
const Dashboard = (params) => {

  const [objListadoInstalacionesCompartidas, setObjListadoInstalacionesCompartidas] = useState([])

  useEffect(() => {   

    document.title = "HELIAS Instalador - Cuadro de mando"

    document.getElementById("search").value = ""

    localStorage.removeItem("activeUserInstallationName")
    localStorage.removeItem("activeUserInstallation")
    localStorage.removeItem("forceUpdate")
    
    cargarDashboard()

    console.log("Dashboard de instalador cargado correctamente.")

  }, []);

  function cargarDashboard(){
    
      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

      //Petición de datos para el paso actual
      var jsonPeticion = {"accountID": localStorage.getItem("accountID"), "installerID": localStorage.getItem("installationId") }

      document.getElementById("loaderGeneralAplicacion").className = "loader overlay"

      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", postListInstallerSharedInstallations, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText)
    
            if(jsonRespuesta.statusCode === "403"){                   
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
            }
            else if(jsonRespuesta.statusCode === "500"){
              document.getElementById("errorInstallationSelectionButton").className = document.getElementById("errorInstallationSelectionButton").className.replaceAll(" hidden", "")
              initialConfigCommonJS.mostrarErrorGeneral("report","ERROR",jsonRespuesta.responseMessage)      
            }
            else{          
              //Si recibo datos ya configurados lo cargo  

              if(typeof jsonRespuesta.body !== 'undefined'){
                
                console.log(jsonRespuesta)       
                setObjListadoInstalacionesCompartidas(jsonRespuesta.body)

                if(jsonRespuesta.body.length === 0) {
                  document.getElementById("buscadorInstalaciones").className = document.getElementById("buscadorInstalaciones").className.replaceAll(" hidden", "") + " hidden"
                }
                else{
                  document.getElementById("buscadorInstalaciones").className = document.getElementById("buscadorInstalaciones").className.replaceAll(" hidden", "")
                }

              }  

              document.getElementById("loaderGeneralAplicacion").className = "loader hidden"

              //Si no hay datos configurados entonces no hago nada  
              console.log("Datos del dashboard cargados correctamente.")
            }
          }
    
          if (this.readyState === 4 && this.status !== 200) {      
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
          }
        }
        xhttp.send(data);     

  }

  return (    
    <main id="mainDashboard">

      <div className="wrapper">

        <div className="row">

          <button className="button" onClick={() => window.location.href="/Advisory/InstallerFeesAnalyzer"}><span className="material-icon">query_stats</span> Analizador 12 facturas</button>

          <div className="col">

            <InstallerSharedInstallations objListadoInstalacionesCompartidas={objListadoInstalacionesCompartidas} seleccionarOpcionMenu={params.seleccionarOpcionMenu} mostrarDetalleWidget={mostrarDetalleWidget}/>
            
          </div>
          
        </div>

      </div>

      <WidgetDetail/>

    </main>
  )
}

export default Dashboard